import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { CallRecordingComponent } from 'src/app/components/call-recording/call-recording.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-employee-call-reports',
  templateUrl: './employee-call-reports.component.html',
  styleUrls: ['./employee-call-reports.component.scss']
})
export class EmployeeCallReportsComponent implements OnInit {

  LoaderComponent: any = '';
  employeeReportForm: FormGroup;
  @ViewChild('successModal')
  successModal: any;
  loginData: any;
  multiDropdownSettings: any = {};
  multiSelectRegionDropdown: any = {};
  multiDropdownSettingsSingle: any = {};
  multiDropdownSettingsSingle1: any = {};
  empID: any;
  regionArray: any = [];
  branchArray: any = [];
  allBranches: any[] = [];
  selectedRegionList: any = [];
  selectedBranchList: any = [];
  selectedBranch: any;
  branchMultiSelectItems: any = [];
  selectedRegion: any;
  empNameMultiSelectItems: any;
  logeedInUser: any;
  callPageArray: any[] = [];
  CallStatusArray:any[] = [];
  maxDate = new Date;
  displayValues: any = [];
  allDisplayValues: any = [];
  headers: any = [];
  allheaders: any = [];
  totalFields: any = [];
  gridType2: any;
  matchedHeaders: any = []
  formValue: any;
  scrollDown: boolean;
  profileTypeArray: any = [];
  responseMessage:any;
  employeeReportData:any;
  loadedAllData: boolean = false;

  constructor(public service: WebRequestService,
    private loginDataStore: Data, public dialog: MatDialog) { }

  ngOnInit() {
    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
        // console.log(this.loginData)
      })
    this.multiDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.multiDropdownSettingsSingle = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
    this.multiDropdownSettingsSingle1 = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };

    this.multiSelectRegionDropdown = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    }
    this.employeeReportForm = new FormGroup({
      branchName: new FormControl(''),
      regionName: new FormControl(''),
      employeeName: new FormControl(null),
      profileId: new FormControl("", [Validators.pattern(/^[0-9\s]*$/)]),
      page: new FormControl(''),
      fromRegistrationDate: new FormControl(''),
      toRegistrationDate: new FormControl(''),
      callStatus: new FormControl(null)
    })
    this.loadBasicData();
    this.allBranches = [
      { id: '', Value: 'All' },
      { id: '408', Value: 'AP' },
      { id: '409', Value: 'TN' },
      { id: '410', Value: 'KT' },
      { id: '1', Value: 'Other' }
    ];
  }

  loadBasicData() {
    this.empID = sessionStorage.getItem('empId')
    this.service.getMasterData().then((response) => {
      if (response['statusCode'] === 200) {
        // console.log(response['result']);

        this.regionArray = response['result'][1];
        this.branchArray = response['result'][2];
        // this.branchArrayList = response['result'][2].name;
        // console.log(this.regionArray)

        this.selectedRegion = [this.getRegion(this.loginData['region'])]
        this.selectedRegionList.push(parseInt(this.loginData['region']))
        this.service.loadMasterDataWithId('StateLocation', this.loginData['region']).then((branchResult) => {
          this.branchMultiSelectItems = branchResult['result'];
          this.selectedBranch = [this.getBranch(this.loginData['branch'])];
        })
          .catch((err) => console.error(err));
        this.service.loadMasterDataWithId('ProfileOwnerbyBranch', parseInt(this.loginData['branch'])).then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];
          // this.logeedInUser = this.queryObj ? this.queryObj['user'][0] : this.getEmployee(this.loginData['employeeID']);

        })
          .catch((err) => console.error(err));

        this.service.loadMasterData('CallPage').then((res) => {
          if (res['statusCode'] === 200) {
            this.callPageArray = res['result'];

          }
        }).catch((err) => { console.log(err) })
        
        this.service.loadMasterData('ConnectedCallFilter').then((res) => {
          if (res['statusCode'] === 200) {
            this.CallStatusArray = res['result'];
          }
        }).catch((err) => { console.log(err) })

      }
    })
  }

  onChange(e) {
    const item = e.target.value.replace(/\D/g, '')
    this.employeeReportForm.patchValue({ 'profileId': item })
  }

  getEmployeeReport(event) {
    this.displayValues = [];
    this.allDisplayValues = [];
    this.LoaderComponent = LoaderComponent;
    this.employeeReportData = {
      branchId: this.employeeReportForm.value.branchName && this.employeeReportForm.value.branchName.length !== 0
        ? this.employeeReportForm.value.branchName.length > 1
          ?
          String(this.employeeReportForm.value.branchName.map((val) => {
            return val.id;
          })
          )
          : String(this.employeeReportForm.value.branchName[0].id)
        : "",
      regionId: this.employeeReportForm.value.regionName && this.employeeReportForm.value.regionName.length !== 0
        ? this.employeeReportForm.value.regionName.length > 1
          ? String(
            this.employeeReportForm.value.regionName.map((val) => {
              return String(val.id);
            })
          )
          : String(this.employeeReportForm.value.regionName[0].id)
        : "",
      fromDate: this.employeeReportForm.value['fromRegistrationDate'] ? this._convertDate(this.employeeReportForm.value['fromRegistrationDate']) : "",
      toDate: this.employeeReportForm.value['toRegistrationDate'] ? this._convertDate(this.employeeReportForm.value['toRegistrationDate']) : "",
      profileID: this.employeeReportForm.value['profileId'] !== null ? this.employeeReportForm.value['profileId'] : "",
      empId: !(this.employeeReportForm.value.employeeName === null || this.employeeReportForm.value.employeeName === undefined || this.employeeReportForm.value.employeeName === "")  ? String(this.employeeReportForm.value.employeeName?.id) : "",
      pageId: this.employeeReportForm.value.page && this.employeeReportForm.value.page.length !== 0
        ? this.employeeReportForm.value.page.length > 1
          ? String(
            this.employeeReportForm.value.page.map((val) => {
              return String(val.id);
            })
          )
          : String(this.employeeReportForm.value.page[0]?.id)
        : "",
        startIndex: 1,
        endIndex: 50,
        CallStatus: !(this.employeeReportForm.value.callStatus === null || this.employeeReportForm.value.callStatus === undefined || this.employeeReportForm.value.callStatus === "")  ? String(this.employeeReportForm.value.callStatus?.id) : "",
    }
    this.service.getEmployeeCallReports(this.employeeReportData).then((res) => {   
      this.displayValues = [];
      this.allDisplayValues = [];
      if (res['statusCode'] === 200) {
        window.scrollTo(0, 0);
        this.LoaderComponent = '';  
        if (res['result'].length > 0) {
          this.allDisplayValues = res['result'];
          this.displayValues = res['result'];
          res['result'].length > 0 ? this.populateHeaders(this.displayValues[0]) : '';
          this.formValue = res['result'][0];
          this.prepareHeaders();
          this.gridType2 = 'logs';
          this.loadedAllData = this.displayValues[0]['totalRows'] === this.displayValues.length ? true : false;
        }else{
          this.LoaderComponent = ''; 
          this.responseMessage = 'No Records Found';
          this.successModal.show()
          setTimeout(()=> {
            this.successModal.hide()
          }, 5000)
        }
      }else{
        this.LoaderComponent = ''; 
        this.responseMessage = 'Please Try Again Later';
        this.successModal.show()
        setTimeout(()=> {
          this.successModal.hide()
        }, 5000)
      }
    })
  }
  loadMore(){
    if(this.employeeReportData['endIndex'] < this.formValue['totalRows']) {
      this.employeeReportData['startIndex'] = this.employeeReportData['endIndex'] + 1;
      this.employeeReportData['endIndex'] = this.employeeReportData['endIndex'] + 50;
      this.requestMoreReports(this.employeeReportData);
      // this.loadedAllData = false;
    } else if (this.employeeReportData['endIndex'] >= this.formValue['totalRows']) {
      this.loadedAllData = true;
    }
    this.scrollDown = true;
  }
  requestMoreReports(data){
    this.LoaderComponent = LoaderComponent;
    this.displayValues = [];
    this.service.getEmployeeCallReports(this.employeeReportData).then(response => {
      if (response['statusCode'] === 200) {
        window.scrollTo(0, 0);
        this.LoaderComponent = '';
        if (response['result'].length > 0) {
          let count = response['result'].length;
          for (let i = 0; i < count; i++) {
            this.allDisplayValues.push(response['result'][i])
          }
          this.displayValues = this.allDisplayValues;
          response['result'].length > 0 ? this.populateHeaders(this.displayValues[0]) : '';
          this.formValue = response['result'][0];
          this.prepareHeaders();
          this.gridType2 = 'logs';
          this.loadedAllData = this.displayValues[0]['totalRows'] === this.displayValues.length ? true : false;
        } else {
          this.responseMessage = "No Data Found";
        }
      } else {
        this.LoaderComponent = '';
        this.responseMessage = response['message'];

      }
    })
  }
  getBranch(id) {
    return this.branchMultiSelectItems.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }
  getRegion(id) {
    return this.regionArray.find(val => {
      if (id == val.id) {
        return val.id;
      }
    })
  }
  getSelectedRegion(event) {
    if (this.selectedRegionList.indexOf(event.id) == -1) {
      this.LoaderComponent = LoaderComponent;
      this.branchMultiSelectItems = [];
      this.selectedRegionList.push(event.id);
      this.service
        .loadMasterDataWithId('StateLocation', this.selectedRegionList)
        .then((branchResult) => {
          if (branchResult['statusCode'] === 200) {
            this.LoaderComponent = "";
            this.selectedBranch = "";
            this.branchMultiSelectItems = branchResult['result'];
            this.logeedInUser = "";
            this.empNameMultiSelectItems = [];
          }
        })
        .catch((err) => { console.error(err) });
    }
  }

  onRegionDeSelect(event) {
    let index = this.selectedRegionList.indexOf(event.id);
    this.employeeReportForm.patchValue({
      branchName: '',
      employeeName: ''
    })
    this.empNameMultiSelectItems = [];
    if (index > -1) {
      this.selectedRegionList.splice(index, 1);
      // console.log(this.selectedRegionList)
      this.branchMultiSelectItems = [];
      this.service
        .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
        .then((empResult) => {
          this.branchMultiSelectItems = empResult['result'];
        })

    }

  }

  onRegionDeSelectAll(event) {
    this.selectedRegionList = event;
    this.branchMultiSelectItems = [];
    this.empNameMultiSelectItems = [];
  }

  onRegionSelectAll(event) {
    // console.log(event)
    this.selectedRegionList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedRegionList.push(event[i]['id'])
    }
    this.branchMultiSelectItems = [];
    // console.log('branch', this.selectedRegionList)
    this.service
      .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
      .then((empResult) => {
        this.branchMultiSelectItems = empResult['result'];
      })
  }
  onBranchItemSelect(event) {
    if (this.selectedBranchList.indexOf(event.id) > -1) {
      let index = this.selectedBranchList.indexOf(event.id);
      this.selectedBranchList.splice(index, 1);
    } else {
      this.empNameMultiSelectItems = [];
      this.selectedBranchList.push(event.id);
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.logeedInUser = "";
          this.empNameMultiSelectItems = empResult['result'];

        })
    }
  }

  onBranchItemDeSelect(event) {
    let index = this.selectedBranchList.indexOf(event.id);
    if (index >= 0) {
      this.selectedBranchList.splice(index, 1);
      this.empNameMultiSelectItems = [];
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];
        })

    }

  }

  onBranchDeSelectAll(event) {
    this.selectedBranchList = event;
    this.empNameMultiSelectItems = [];
  }
  onBrachItemsSelectAll(event) {
    this.selectedBranchList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedBranchList.push(event[i]['id'])
    }
    this.empNameMultiSelectItems = [];
    this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
      .then((empResult) => {
        this.empNameMultiSelectItems = empResult['result'];
      })
  }

  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [year, month, day].join('-');
  }

  populateHeaders(data: any) {
    this.allheaders = Object.keys(data).length > 0 ? Object.keys(data) : [];
  }

  prepareHeaders() {
    this.totalFields = [
      
      { name: 'Profile ID', id: 'ProfileId' },
      { name: 'Customer Name', id: 'customerName' },
      { name: 'Employee Name', id: 'employeeName' },
      { name: 'Call Duration', id: 'callDuration' },
      { name: 'Call Date', id: 'callDate' },
      { name: 'Call Reason', id: 'callReason' },
      { name: 'Page Name', id: 'PageName' },
      { name: 'Call Recording', id: 'callRecording' },
      { name: 'Relation', id: 'RelationType' },
      { name: 'Call Status', id: 'CallStatuseCode' }
    ]
    this.matchedHeaders = [
      
      { name: 'Profile ID', id: 'ProfileId' },
      { name: 'Customer Name', id: 'customerName' },
      { name: 'Employee Name', id: 'employeeName' },
      { name: 'Call Duration', id: 'callDuration' },
      { name: 'Call Date', id: 'callDate' },
      { name: 'Call Reason', id: 'callReason' },
      { name: 'Page Name', id: 'PageName' },
      { name: 'Call Recording', id: 'callRecording' },
      { name: 'Relation', id: 'RelationType' },
      { name: 'Call Status', id: 'CallStatuseCode' }
    ]
    this.headers = [
      'rowID', 'ProfileId', 'customerName', 'employeeName', 'callDate', 'callReason','CallStatuseCode', 'callDuration', 'callRecording', 'RelationType', 'PageName'
    ]
  }
  playRecording(url) {
    const dialogRef = this.dialog.open(CallRecordingComponent, {
      width: '475px',
      height: '17vw',
      data: {
        page: 'Edit-view',
        audioSrc: url
      }
    });
  }

}
